
import { Box, Stack } from "@mui/material";
import { IdentificationSection } from "./components/IdentificationSection";
import { SafetyMeasuresSection } from "./components/SafetyMeasuresSection";
import { ParentAndPatientInfoSection } from "./components/ParentAndPatientInfoSection";
import { VitalSignsSection } from "./components/VitalSignsSection";
import { PregnancyInfoSection } from "./components/PregnancyInfoSection";
import { NeedsSection } from "./components/NeedsSection";

//YATAY;452641;18042025
function PageOne() {
  return (
    <Box sx={{ p: 2 }}>
      <Stack spacing={4}>
        <IdentificationSection />
        <SafetyMeasuresSection />
        <ParentAndPatientInfoSection />
        <Box sx={{ border: "1px solid #DBDBDB", borderRadius: "4px", padding: "20px" }}>
          <VitalSignsSection />
        </Box>
        <PregnancyInfoSection />
        <NeedsSection />
      </Stack>
    </Box>
  );
}

export default PageOne;
